import styled from 'styled-components'
import "../../../variables.scss"

export const TextInputLabel = styled.label<{
    color: string
    background: string
    textAlign: string
}>`
    padding: 0.2em 0.5em 0.2em 0;
    line-height: 1.4;
    color: ${({color}) => (color ? color : 'rgba(0,0,0,0.5)')};
    background: ${({background}) => (background ? background : '#ffffff')};
    textAlign: ${({textAlign}) => (textAlign ? textAlign : 'left')};
    white-space: nowrap;
    text-overflow: ellipsis;
    display: block;
    margin-bottom: 0;
`
